module.exports = __webpack_public_path__ + "img/ui_nike_flair_b.3fb798c8.png";